module.exports = ".odd {\r\n    color: purple;\r\n}\r\n\r\n.even {\r\n    color: seagreen;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/assigment-cmp-databinding/assigment-cmp-databinding.component.css
// module id = ./src/app/components/assigment-cmp-databinding/assigment-cmp-databinding.component.css
// module chunks = main